import { Icon } from "semantic-ui-react";

export default Icon;
